// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_ygvgx","itemPic":"index_itemPic_3HQYT"};